<div class="add-utility-root">
  <div class="action-buttons" *ngIf="bpsAdminLevel != 2">
    <button class="btn btn-header" *ngIf="!editEnabled" (click)="edit()">
      Edit
    </button>
    <button class="btn btn-primary" *ngIf="editEnabled" (click)="validate()">
      Save
    </button>
  </div>
  <div *ngIf="selectedUtility != null" class="ac-body">
    <div *ngIf="!editEnabled" class="corner">
      <img height="50" width="50" src="{{ selectedUtility.imageUrl }}" alt="Utitlity image" />
      <h2>{{ selectedUtility.subdomain }}</h2>
      <span>{{ selectedUtility.colorCode }}</span>
      <br />
      <span>Currency : {{ selectedUtility.currency }}</span>
    </div>
    <div class="padding" *ngIf="editEnabled">
      <div class="container card form-wrapper">
        <div class="row">
          <div class="col-6 form-item form-floating mb-3">
            <input [(ngModel)]="selectedUtility.subdomain" name="subdomain" type="text" class="form-control"
              id="floatingInput2" placeholder=" " required />
            <label for="floatingInput2">Subdomain</label>
          </div>
          <div class="col-6 form-item form-floating mb-3">
            <input [(ngModel)]="selectedUtility.name" name="name" type="text" class="form-control" id="floatingInput2"
              placeholder=" " required />
            <label for="floatingInput2">Name</label>
          </div>
        </div>
        <label class="logo-label">Utility logo</label>
        <div *ngIf="imageSrc == ''; else image" class="drag-drop col-12" appDragAndDrop
          (fileDropped)="onFileDropped($event)">
          <input type="file" id="fileDropRef" name="utilityImage" #utilityImage
            accept="image/png, image/jpg, image/jpeg" (change)="fileBrowserHandler($event)" />
          <div class="upload-img">
            <img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" />
          </div>
          <label for="fileDropRef">Drag and drop file here or <span class="browse">Browse</span> to
            upload</label>
        </div>
        <ng-template #image>
          <div class="pb-4">
            <img alt="Upload image" height="75" width="75" style="max-width: 100%" src="{{ imageSrc }}" />
            <span (click)="removeImage()">x</span>
          </div>
        </ng-template>
        <div class="row">
          <div class="col-6 form-item form-floating mb-3">
            <input id="color-test" type="color" [(ngModel)]="selectedUtility.colorCode" name="floatingInput2"
              class="input-color" />
            <input name="color" [(ngModel)]="selectedUtility.colorCode" cpOutputFormat="hex" class="form-control"
              id="floatingInput2" placeholder=" " readonly />

            <label *ngIf="selectedUtility.colorCode != ''" for="floatingInput2">{{ selectedUtility.colorCode }}</label>
          </div>
          <select name="currency-select" (change)="selectCurrency($event)" class="col-6 form-item">
            <option value="" [selected]="!selectedUtility.currency" disabled>Currency</option>
            <option [selected]="selectedUtility.currency == c.code" *ngFor="let c of currencyList" value="{{ c.code }}">
              {{ c.text }}
            </option>
          </select>
        </div>
        <div class="row">
          <select name="country-select" (change)="selectCountry($event)" class="col-6 form-item">
            <option value="" [selected]="!selectedUtility.country" disabled>Country</option>
            <option [selected]="selectedUtility.country == c.code" *ngFor="let c of countryList" value="{{ c.code }}">
              {{ c.text }}
            </option>
          </select>
          <select name="language-select" (change)="selectLanguage($event)" class="col-6 form-item">
            <option value="" [selected]="!selectedUtility.language" disabled>Language</option>
            <option [selected]="selectedUtility.language == c.code" *ngFor="let c of languageList" value="{{ c.code }}">
              {{ c.text }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="filled-card">
      <div *ngIf="selectedUtility != null" class="container card">
        <div class="row">
          <div class="col-3">
            <span class="col-title">Asset</span>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Map])"
                    (change)="onChange([Configuration.Map], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Map</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.AIDroneMap])"
                    (change)="onChange([Configuration.AIDroneMap], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">AI UAV</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.InjectionSubstation])"
                    (change)="onChange([Configuration.InjectionSubstation], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Injection Substation</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Feeders])"
                    (change)="onChange([Configuration.Feeders], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Feeders(33KV,11KV)</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.FeederBands])"
                    (change)="onChange([Configuration.FeederBands], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">{{ 'UTILITY_MANAGEMENT.FEEDER_BANDS' | translate }}</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.DTs])"
                    (change)="onChange([Configuration.DTs], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Distribution Substation</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Rmus])"
                    (change)="onChange([Configuration.Rmus], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">RMU</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.MVPoles])"
                    (change)="onChange([Configuration.MVPoles], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">MV Poles</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Poles])"
                    (change)="onChange([Configuration.Poles], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">LT Poles</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Buildings])"
                    (change)="onChange([Configuration.Buildings], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Buildings</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Meters])"
                    (change)="onChange([Configuration.Meters], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Meters</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.NetworkModelStructure])"
                    (change)="onChange([Configuration.NetworkModelStructure], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Network Structure</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.NetworkEntityClassInstantiation])"
                    (change)="onChange([Configuration.NetworkEntityClassInstantiation], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Network Entity Class</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.DataModelCustomization])"
                    (change)="onChange([Configuration.DataModelCustomization], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Data Model Customization</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.NewService])"
                    (change)="onChange([Configuration.NewService], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">New Service</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled || isChecked([Configuration.CIMDataIntegration])" type="checkbox"
                    [checked]="isChecked([Configuration.CIMDataIntegration])"
                    (change)="onChange([Configuration.CIMDataIntegration], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">CIM Data Integration</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.GalleryAccessAssets])"
                    (change)="onChange([Configuration.GalleryAccessAssets], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Gallery Access</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.AiWidget])"
                    (change)="onChange([Configuration.AiWidget], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">AI Widget</label>
              </div>
            </div>
          </div>
          <div class="col-3">
            <span class="col-title">Operations</span>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Survey])"
                    (change)="onChange([Configuration.Survey], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Survey</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Installation])"
                    (change)="onChange([Configuration.Installation], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Customer Installation</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.DtMeterInstallation])"
                    (change)="onChange([Configuration.DtMeterInstallation], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">DT Meter Installation</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.OnlineMeterNumberScan])"
                    (change)="onChange([Configuration.OnlineMeterNumberScan], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Online Meter Number Scan</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.WorkOrder])"
                    (change)="onChange([Configuration.WorkOrder], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Work order</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.CustomerInformationEdit])"
                    (change)="onChange([Configuration.CustomerInformationEdit], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Customer Information Edit </label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.PaymentHistory])"
                    (change)="onChange([Configuration.PaymentHistory], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Payment History</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.GalleryAccessOperations])"
                    (change)="onChange([Configuration.GalleryAccessOperations], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Gallery Access</label>
              </div>
            </div>
            <div class="headerComponent mb-4">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Settlement])"
                    (change)="onChange([Configuration.Settlement], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Settlement</label>
              </div>
            </div>
            <span class="col-title">Meter Validation</span>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.MeterValidation])"
                    (change)="onChange([Configuration.MeterValidation], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Meter Validation</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled || !isChecked([Configuration.MeterValidation])" type="checkbox"
                    [checked]="isChecked([Configuration.MeterValidationTamper])"
                    (change)="onChange([Configuration.MeterValidationTamper], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Tamper</label>
              </div>
            </div>

            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled || !isChecked([Configuration.MeterValidation])" type="checkbox"
                    [checked]="isChecked([Configuration.DtConfirmation])"
                    (change)="onChange([Configuration.DtConfirmation], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">DS Confirmation</label>
              </div>
            </div>
          </div>

          <div class="col-3">
            <span class="col-title">Meter management</span>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.MeterCustomers])"
                    (change)="onChange([Configuration.MeterCustomers], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Customers</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.MeterAssets])"
                    (change)="onChange([Configuration.MeterAssets], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Assets</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.MeterApprovalAndRepayment])"
                    (change)="onChange([Configuration.MeterApprovalAndRepayment], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Meter Approval &amp; Repayment</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.MeterCtvt])"
                    (change)="onChange([Configuration.MeterCtvt], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">CT/VT</label>
              </div>
            </div>
          </div>

          <div class="col-3">
            <span class="col-title">Customer management</span>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.CustomerManagement])"
                    (change)="onChange([Configuration.CustomerManagement], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Customer management</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.StandaloneBillingIntegration])"
                    (change)="onChange([Configuration.StandaloneBillingIntegration], $event)">
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Payment and Vend</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.AccountCreation])"
                    (change)="onChange([Configuration.AccountCreation], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Account Creation</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.EnergySource])"
                    (change)="onChange([Configuration.EnergySource], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Energy Source</label>
              </div>
            </div>
          </div>

          <div class="col-3 mt-4">
            <span class="col-title">Readings</span>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox" [checked]="isChecked([Configuration.Readings])"
                    (change)="onChange([Configuration.Readings], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Customer Meter Reading</label>
              </div>
            </div>
            <div class="headerComponent">
              <div>
                <label class="switch">
                  <input [disabled]="!editEnabled" type="checkbox"
                    [checked]="isChecked([Configuration.StandaloneBillingIntegration])"
                    (change)="onChange([Configuration.StandaloneBillingIntegration], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Billing Integration</label>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <span class="col-title">Map configuration</span>

          <div class="map-config">
            <div class="config-item">
              <span class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path d="M12 10c-1.104 0-2-.896-2-2s.896-2 2-2 
                  2 .896 2 2-.896 2-2 2m0-5c-1.657 0-3 1.343-3 
                  3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m-7 
                  2.602c0-3.517 3.271-6.602 7-6.602s7 3.085 
                  7 6.602c0 3.455-2.563 7.543-7 
                  14.527-4.489-7.073-7-11.072-7-14.527m7-7.602c-4.198 
                  0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 
                  16.398 4.531-7.188 8-12.2 8-16.398 
                  0-4.199-3.801-7.602-8-7.602" />
                </svg>
              </span>
              <span class="config-text">{{ selectedUtility.mapConfiguration?.latitude | hasValue }}, {{
                selectedUtility.mapConfiguration?.longitude | hasValue }}</span>
            </div>

            <div class="config-item">
              <span class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path d="m15.97 17.031c-1.479 1.238-3.384 1.985-5.461 
                  1.985-4.697 0-8.509-3.812-8.509-8.508s3.812-8.508 
                  8.509-8.508c4.695 0 8.508 3.812 8.508 8.508 0 
                  2.078-.747 3.984-1.985 5.461l4.749 
                  4.75c.146.146.219.338.219.531 0 .587-.537.75-.75.75-.192 
                  0-.384-.073-.531-.22zm-5.461-13.53c-3.868 0-7.007 
                  3.14-7.007 7.007s3.139 7.007 7.007 7.007c3.866 0 
                  7.007-3.14 7.007-7.007s-3.141-7.007-7.007-7.007zm-.744 
                  6.26h-2.5c-.414 0-.75.336-.75.75s.336.75.75.75h2.5v2.5c0 
                  .414.336.75.75.75s.75-.336.75-.75v-2.5h2.5c.414 
                  0 .75-.336.75-.75s-.336-.75-.75-.75h-2.5v-2.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75z" />
                </svg>
              </span>
              <span class="config-text">{{ selectedUtility.mapConfiguration?.zoom | hasValue }}</span>
            </div>
            <div *ngIf="editEnabled" class="config-item configure-map" data-bs-toggle="modal" data-bs-target="#showMap">
              <span class="icon">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                  <path
                    d="M2.458 9.012c-.297.947-.458 1.955-.458 3 0 5.52 4.481 10 10 10 5.52 0 10-4.48 10-10 0-5.519-4.48-10-10-10-2.121 0-4.083.668-5.703 1.796l1.703 2.204h-6.58l1.935-6.012 1.718 2.223c1.958-1.389 4.346-2.211 6.927-2.211 6.623 0 12 5.377 12 12s-5.377 11.988-12 11.988-12-5.365-12-11.988c0-1.036.132-2.041.379-3h2.079zm10.35-3.012c.292.821.375 1.346 1.01 1.609.637.264 1.073-.052 1.854-.423l1.142 1.142c-.373.787-.687 1.218-.423 1.854.262.634.784.716 1.609 1.009v1.617c-.816.29-1.347.375-1.61 1.01-.264.636.052 1.071.424 1.853l-1.142 1.142c-.79-.375-1.219-.687-1.85-.424-.639.265-.723.793-1.014 1.611h-1.616c-.292-.821-.375-1.347-1.01-1.61-.637-.264-1.072.052-1.854.423l-1.142-1.142c.366-.771.689-1.212.423-1.854-.263-.635-.793-.719-1.609-1.009v-1.617c.817-.29 1.346-.373 1.609-1.009.264-.637-.051-1.07-.423-1.854l1.142-1.142c.788.374 1.218.687 1.854.423.635-.263.719-.792 1.01-1.609h1.616zm-.808 8c-1.105 0-2-.896-2-2 0-1.105.895-2.001 2-2.001 1.104 0 2 .896 2 2.001 0 1.104-.896 2-2 2z" />
                </svg>
              </span>
              <span class="configure-map-text">Configure map</span>
            </div>
          </div>

        </div>
        <div class="mt-4 col-3">
          <span class="col-title">Limit assigned areas for mobile users</span>
          <div class="btn-group mt-4">
            <button class="btn" [disabled]="!editEnabled" [class.btn-primary]="!selectedUtility.isSelectedAreasForMobileLimited"
              [class.btn-outline-primary]="selectedUtility.isSelectedAreasForMobileLimited"
              (click)="selectedUtility.isSelectedAreasForMobileLimited = false">
              Unlimited
            </button>
        
            <button class="btn" [disabled]="!editEnabled" [class.btn-primary]="selectedUtility.isSelectedAreasForMobileLimited"
              [class.btn-outline-primary]="!selectedUtility.isSelectedAreasForMobileLimited"
              (click)="selectedUtility.isSelectedAreasForMobileLimited = true">
              Limited
            </button>
          </div>
          <div class="mt-3" *ngIf="selectedUtility.isSelectedAreasForMobileLimited">
            <input type="number" class="form-control limit-input" [(ngModel)]="selectedUtility.maximumSelectedAreasForMobile"
              (blur)="validateLimit()" min="1" placeholder="Enter limit" />
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="editEnabled" class="filled-card">
      <div class="container card">
        <div class="row">
          <div class="container-fluid border-bottom">
            <table>
              <tr class="header-row">
                <th>KEY</th>
                <th>VALUE</th>
              </tr>
              <tr class="content-wrapper" (click)="selectTranslation(item)"
                *ngFor="let item of selectedUtility.translations" data-bs-toggle="modal"
                data-bs-target="#changeTranslation">
                <td>{{ item.key }}</td>
                <td>{{ item.value }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!editEnabled" class="filled-card">
      <div class="container card">
        <span class="col-title">Translations</span>
        <div class="row translations">
          <div class="col-6">
            <div class="col-subtitle row" *ngFor="let item of selectedUtility.translations">
              {{ item.key }} : {{ item.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filled-card">
      <div class="container card">
        <div class="validation-rules-header d-flex align-items-center justify-content-between">
          <span class="col-title">Validation Rules</span>
          <button class="btn btn-header" *ngIf="editEnabled" data-bs-toggle="modal"
            data-bs-target="#validationRuleModal" (click)="openNewValidationRule()">
            Add New
          </button>
        </div>
        <div class="row">
          <div class="container-fluid border-bottom">
            <table>
              <tr class="header-row">
                <th>Property Type</th>
                <th>Scope</th>
                <th>Starts with</th>
                <th>Alfanumeric</th>
                <th>Regular Expression</th>
              </tr>
              <tr class="content-wrapper" *ngFor="let item of selectedUtility.validationRules; let i = index"
                [attr.data-bs-toggle]="editEnabled ? 'modal' : null"
                [attr.data-bs-target]="editEnabled ? '#validationRuleModal' : null"
                (click)="editEnabled && selectValidationRule(item, i)">
                <td>{{ getValidationRuleLabel(item.propertyType) }}</td>
                <td>{{ getValidationRuleScopeLabel(item) }}</td>
                <td>{{ item.startsWith | hasValue }}</td>
                <td>{{ item.isAlfaNumeric == true ? "Yes" : "No" }}</td>
                <td>{{ item.regExp | hasValue }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="filled-card">
      <div class="container card">
        <div class="validation-rules-header d-flex align-items-center justify-content-between">
          <span class="col-title">Configuration Generation</span>
          <button class="btn btn-header" *ngIf="editEnabled" data-bs-toggle="modal"
            data-bs-target="#configurationGenerationModal" [class.disabled]="!isAddNewConfigurationGenerationEnabled"
            (click)="openNewConfigurationGeneration()">
            Add New
          </button>
        </div>
        <div class="row">
          <div class="container-fluid border-bottom">
            <table>
              <tr class="header-row">
                <th>Property Type</th>
                <th>Character Length</th>
                <th>Format Type</th>
                <th>Starts with</th>
                <th>Locked</th>
              </tr>
              <tr class="content-wrapper" *ngFor="let item of selectedUtility.configurationGenerations"
                (click)="onRowClick(item)">
                <td [attr.data-bs-toggle]="item.id === 0 ? 'modal' : null"
                  [attr.data-bs-target]="item.id === 0 ? '#configurationGenerationModal' : null">
                  {{ getConfigurationGenerationPropertyTypeLabel(item.propertyType) }}
                </td>
                <td [attr.data-bs-toggle]="item.id === 0 ? 'modal' : null"
                  [attr.data-bs-target]="item.id === 0 ? '#configurationGenerationModal' : null">
                  {{ item.length }}
                </td>
                <td [attr.data-bs-toggle]="item.id === 0 ? 'modal' : null"
                  [attr.data-bs-target]="item.id === 0 ? '#configurationGenerationModal' : null">
                  {{ getFormatTypeLabel(item.formatType) }}
                </td>
                <td [attr.data-bs-toggle]="item.id === 0 ? 'modal' : null"
                  [attr.data-bs-target]="item.id === 0 ? '#configurationGenerationModal' : null">
                  {{ item.startsWith }}
                </td>
                <td>
                  <svg *ngIf="item.id !== 0" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#000"
                    class="bi bi-lock" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M8 0a4 4 0 0 1 4 4v2.05a2.5 2.5 0 0 1 2 2.45v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5v-5a2.5 2.5 0 0 1 2-2.45V4a4 4 0 0 1 4-4M4.5 7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7zM8 1a3 3 0 0 0-3 3v2h6V4a3 3 0 0 0-3-3" />
                  </svg>
                  <svg *ngIf="item.id === 0" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                    fill="currentColor" class="bi bi-unlock" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M12 0a4 4 0 0 1 4 4v2.5h-1V4a3 3 0 1 0-6 0v2h.5A2.5 2.5 0 0 1 12 8.5v5A2.5 2.5 0 0 1 9.5 16h-7A2.5 2.5 0 0 1 0 13.5v-5A2.5 2.5 0 0 1 2.5 6H8V4a4 4 0 0 1 4-4M2.5 7A1.5 1.5 0 0 0 1 8.5v5A1.5 1.5 0 0 0 2.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 9.5 7z" />
                  </svg>
                  <svg (click)="delete($event, item); $event.stopImmediatePropagation()" class="delete-config"
                    *ngIf="item.id === 0" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.75 5C2.33579 5 2 5.33579 2 5.75C2 6.16421 2.33579 6.5 2.75 6.5V5ZM21.25 6.5C21.6642 6.5 22 6.16421 22 5.75C22 5.33579 21.6642 5 21.25 5V6.5ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75H10.5ZM9 16.25C9 16.6642 9.33579 17 9.75 17C10.1642 17 10.5 16.6642 10.5 16.25H9ZM15 10.75C15 10.3358 14.6642 10 14.25 10C13.8358 10 13.5 10.3358 13.5 10.75H15ZM13.5 16.25C13.5 16.6642 13.8358 17 14.25 17C14.6642 17 15 16.6642 15 16.25H13.5ZM15.1477 5.93694C15.2509 6.33808 15.6598 6.57957 16.0609 6.47633C16.4621 6.37308 16.7036 5.9642 16.6003 5.56306L15.1477 5.93694ZM4.00156 5.79829L4.82047 18.4914L6.31736 18.3949L5.49844 5.70171L4.00156 5.79829ZM8.56269 22H15.4373V20.5H8.56269V22ZM19.1795 18.4914L19.9984 5.79829L18.5016 5.70171L17.6826 18.3949L19.1795 18.4914ZM19.25 5H4.75V6.5H19.25V5ZM2.75 6.5H4.75V5H2.75V6.5ZM19.25 6.5H21.25V5H19.25V6.5ZM15.4373 22C17.4146 22 19.0522 20.4647 19.1795 18.4914L17.6826 18.3949C17.6063 19.5788 16.6237 20.5 15.4373 20.5V22ZM4.82047 18.4914C4.94777 20.4647 6.58535 22 8.56269 22V20.5C7.37629 20.5 6.39374 19.5788 6.31736 18.3949L4.82047 18.4914ZM9 10.75V16.25H10.5V10.75H9ZM13.5 10.75V16.25H15V10.75H13.5ZM12 3.5C13.5134 3.5 14.7868 4.53504 15.1477 5.93694L16.6003 5.56306C16.0731 3.51451 14.2144 2 12 2V3.5ZM8.85237 5.93694C9.21319 4.53504 10.4867 3.5 12 3.5V2C9.78568 2 7.92697 3.51451 7.39971 5.56306L8.85237 5.93694Z"
                      fill="#17171A" fill-opacity="0.9" />
                  </svg>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="editEnabled" class="filled-card">
      <div class="container card">
        <div class="code-rules-header">
          <span class="col-title">Electrical Address Code Rules</span>
          <div class="headerComponent code-rules-toggle">
            <label class="switch">
              <input [disabled]="!editEnabled" type="checkbox"
                [checked]="selectedUtility.defaultCaimsCodePatterns"
                (change)="onCodePatternsToggle($event)" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="row" [class.inactive-config]="!selectedUtility.defaultCaimsCodePatterns">
          <div class="container-fluid border-bottom">
            <table>
              <tr class="header-row">
                <th>Asset Type</th>
                <th>Pattern</th>
                <th>Prefix</th>
              </tr>
              <tr class="content-wrapper" (click)="selectCodePattern(item)"
                *ngFor="let item of selectedUtility.codePatterns" data-bs-toggle="modal"
                data-bs-target="#changeCodePattern">
                <td>{{ item.displayAssetType }}</td>
                <td>{{ item.displayPatternOption }}</td>
                <td>{{ item.prefix }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="editEnabled" class="filled-card">
      <div class="container card">
        <div class="code-rules-header">
          <span class="col-title">CIN</span>
          <div class="headerComponent code-rules-toggle">
            <label class="switch">
              <input [disabled]="!editEnabled" type="checkbox"
                [checked]="!selectedUtility.defaultCaimsCodePatterns"
                (change)="onCinPatternsToggle($event)" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="row translations" [class.inactive-config]="selectedUtility.defaultCaimsCodePatterns">
          <div class="col-6">
            <div class="col-subtitle row" *ngFor="let item of cinAssetTypes">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!editEnabled" class="filled-card">
      <div class="container card">
        <div class="code-rules-header">
          <span class="col-title">Electrical Address Code Rules</span>
          <div class="headerComponent code-rules-toggle">
            <label class="switch">
              <input [disabled]="!editEnabled" type="checkbox"
                [checked]="selectedUtility.defaultCaimsCodePatterns"
                (change)="onCodePatternsToggle($event)" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="row translations" [class.inactive-config]="!selectedUtility.defaultCaimsCodePatterns">
          <div class="col-6">
            <div class="col-subtitle row" *ngFor="let item of selectedUtility.codePatterns">
              {{ item.displayAssetType }} : {{ item.prefix }}{{ item.prefix ? ' + ' : '' }}{{ item.displayPatternOption
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!editEnabled" class="filled-card">
      <div class="container card">
        <div class="code-rules-header">
          <span class="col-title">CIN</span>
          <div class="headerComponent code-rules-toggle">
            <label class="switch">
              <input [disabled]="!editEnabled" type="checkbox"
                [checked]="!selectedUtility.defaultCaimsCodePatterns"
                (change)="onCinPatternsToggle($event)" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="row translations" [class.inactive-config]="selectedUtility.defaultCaimsCodePatterns">
          <div class="col-6">
            <div class="col-subtitle row" *ngFor="let item of cinAssetTypes">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="padding" *ngIf="editEnabled">
      <div class="container card form-wrapper">
        <div class="row">
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="
                selectedUtility.kycConsentConfiguration.regulatoryCommission
              " name="regulatoryCommission" type="text" class="form-control" id="floatingInput2" placeholder=" "
              required />
            <label for="floatingInput2">Regulatory Commission</label>
          </div>
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="
                selectedUtility.kycConsentConfiguration.electricityReform
              " name="electricityReform" type="text" class="form-control" id="floatingInput2" placeholder=" "
              required />
            <label for="floatingInput2">Electricity Reform</label>
          </div>
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="
                selectedUtility.kycConsentConfiguration.networkRegulation
              " name="networkRegulation" type="text" class="form-control" id="floatingInput2" placeholder=" "
              required />
            <label for="floatingInput2">Network Regulation</label>
          </div>
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="
                selectedUtility.kycConsentConfiguration.electricityManagement
              " name="electricityManagement" type="text" class="form-control" id="floatingInput2" placeholder=" "
              required />
            <label for="floatingInput2">Electricity Management</label>
          </div>
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="selectedUtility.kycConsentConfiguration.country" name="country" type="text"
              class="form-control" id="floatingInput2" placeholder=" " required />
            <label for="floatingInput2">Country</label>
          </div>
          <div class="headerComponent cookie-toggle-edit">
            <div>
              <label class="switch">
                <input type="checkbox" [checked]="selectedUtility.kycConsentConfiguration.cookieConsentEnabled"
                  (change)="selectedUtility.kycConsentConfiguration.cookieConsentEnabled = !selectedUtility.kycConsentConfiguration.cookieConsentEnabled" />
                <span class="slider round"></span>
              </label>
            </div>
            <div>
              <label class="title cookie-title">Requires Cookie Consent</label>
            </div>
          </div>
        </div>
        <label class="logo-label">Service Request Image Configuration</label>
        <div *ngIf="selectedUtility.kycConsentConfiguration.serviceRequestImageUrl == null ; else imageService"
          class="drag-drop col-12" appDragAndDrop (fileDropped)="onServiceFileDropped($event)">
          <input type="file" id="fileDropRef" name="serviceImage" #serviceImage
            accept="image/png, image/jpg, image/jpeg" (change)="serviceFileBrowserHandler($event)" />
          <div class="upload-img">
            <img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" />
          </div>
          <label for="fileDropRef">Drag and drop file here or <span class="browse">Browse</span> to
            upload</label>
        </div>
        <ng-template #imageService>
          <div class="pb-4">
            <img alt="Upload image" height="75" width="75" style="max-width: 100%"
              src="{{ selectedUtility.kycConsentConfiguration.serviceRequestImageUrl }}" />
            <span (click)="removeServiceImage()">x</span>
          </div>
        </ng-template>

      </div>



    </div>
    <div *ngIf="!editEnabled" class="filled-card">
      <div class="container card">
        <span class="col-title">Service Request Consent Configuration</span>
        <div class="row translations">
          <div class="col-12">
            <div class="col-subtitle row">
              Regulatory Commission:
              {{
              this.selectedUtility.kycConsentConfiguration
              ?.regulatoryCommission
              }}
            </div>
            <div class="col-subtitle row">
              Electricity Reform:
              {{
              this.selectedUtility.kycConsentConfiguration?.electricityReform
              }}
            </div>
            <div class="col-subtitle row">
              Network Regulation:
              {{
              this.selectedUtility.kycConsentConfiguration?.networkRegulation
              }}
            </div>
            <div class="col-subtitle row">
              Electricity Management:
              {{
              this.selectedUtility.kycConsentConfiguration
              ?.electricityManagement
              }}
            </div>
            <div class="col-subtitle row">
              Country:
              {{ this.selectedUtility.kycConsentConfiguration?.country }}
            </div>
            <div class="headerComponent cookie-toggle">
              <div>
                <label class="switch">
                  <input [disabled]="true" type="checkbox"
                    [checked]="selectedUtility.kycConsentConfiguration.cookieConsentEnabled" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title cookie-title">Requires Cookie Consent</label>
              </div>
            </div>
            <div class="col-subtitle row">
              <label class="logo-label">Service Request Image Configuration</label>
              <div class="pb-4">
                <img alt="Upload image" height="75" width="75" style="max-width: 100%"
                  src="{{ selectedUtility.kycConsentConfiguration.serviceRequestImageUrl }}" />

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="padding" *ngIf="editEnabled">
      <div class="container card form-wrapper">
        <div class="row">
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="selectedUtility.bankDetails.bankName" name="bankName" type="text" class="form-control"
              id="floatingInput2" placeholder=" " required />
            <label for="floatingInput2">Bank Name</label>
          </div>
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="selectedUtility.bankDetails.accountName" name="accountName" type="text"
              class="form-control" id="floatingInput2" placeholder=" " required />
            <label for="floatingInput2">Account Name</label>
          </div>
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="selectedUtility.bankDetails.accountNumber" name="accountNumber" type="text"
              class="form-control" id="floatingInput2" placeholder=" " required />
            <label for="floatingInput2">Account Number</label>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!editEnabled" class="filled-card">
      <div class="container card">
        <span class="col-title">Bank Account Information</span>
        <div class="row translations">
          <div class="col-12">
            <div class="col-subtitle row">
              Bank Name: {{ this.selectedUtility.bankDetails?.bankName }}
            </div>
            <div class="col-subtitle row">
              Account Name: {{ this.selectedUtility.bankDetails?.accountName }}
            </div>
            <div class="col-subtitle row">
              Account Number:
              {{ this.selectedUtility.bankDetails?.accountNumber }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="padding" *ngIf="editEnabled">
      <div class="container card form-wrapper">
        <div class="row">
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="selectedUtility.senderEmail" name="senderEmail" type="text" class="form-control"
              id="floatingInput2" placeholder=" " required />
            <label for="floatingInput2">Sender Email Address</label>
          </div>
          <div class="col-12 form-item form-floating mb-3">
            <input [(ngModel)]="selectedUtility.sendgridApiKey" name="sendgridApiKey" type="text"
              class="form-control" id="floatingInput2" placeholder=" " required />
            <label for="floatingInput2">API Key</label>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!editEnabled" class="filled-card">
      <div class="container card">
        <span class="col-title">Email Sender Configuration</span>
        <div class="row translations">
          <div class="col-12">
            <div class="col-subtitle row">
              Sender Email Address: {{ this.selectedUtility.senderEmail }}
            </div>
            <div class="col-subtitle row">
              API Key: {{ this.selectedUtility.sendgridApiKey }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="filled-card">
      <div class="container card">
        <span class="col-title">Contact Person</span>
        <div class="row translations">
          <div class="col-12">
            <div class="col-subtitle row">
              First Name: {{ this.selectedUtility.contactPerson?.firstName }}
            </div>
            <div class="col-subtitle row">
              Last Name: {{ this.selectedUtility.contactPerson?.lastName }}
            </div>
            <div class="col-subtitle row">
              Email: {{ this.selectedUtility.contactPerson?.eMail }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade validation-rule-modal" id="validationRuleModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="validationRuleModalTitle">
          Validation Rule
        </h5>
        <button type="button" #closeValidationModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close"
          (click)="resetValidationRuleModal()">
          Cancel
        </button>
      </div>
      <form id="validationRuleForm" class="form-wrapper" ngNativeValidate>
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <select id="validation-rule-property" name="validation-rule-property"
              [(ngModel)]="selectedValidationRule.propertyType" (ngModelChange)="onValidationRuleTypeChange($event)"
              [disabled]="isEditingValidationRule"
              [ngClass]="selectedValidationRule.propertyType != null ? 'selected-option' : ''" class="form-select"
              required>
              <option [ngValue]="null" disabled>Property Type</option>
              <option *ngFor="let ruleType of availableValidationRuleTypeOptions" [ngValue]="ruleType.value">
                {{ ruleType.label }}
              </option>
            </select>
            <label *ngIf="selectedValidationRule.propertyType != null" class="label-for-select"
              for="validation-rule-property">Property Type</label>
            <div *ngIf="selectedValidationRule.propertyType != null" class="select-title"></div>
          </div>
          <div class="form-item form-floating mb-3" *ngIf="activeSpecialConfig">
            <select id="validation-rule-scope" name="validation-rule-scope" [(ngModel)]="selectedValidationRule.scopeId"
              [ngClass]="selectedValidationRule.scopeId != null ? 'selected-option' : ''" class="form-select"
              [required]="activeSpecialConfig.required">
              <option [ngValue]="null" disabled>{{ activeSpecialConfig.placeholder }}</option>
              <option *ngFor="let option of activeScopeOptions" [ngValue]="option.id">
                {{ option.label }}
              </option>
            </select>
            <label *ngIf="selectedValidationRule.scopeId != null" class="label-for-select" for="validation-rule-scope">
              {{ activeSpecialConfig.fieldLabel }}
            </label>
            <div *ngIf="selectedValidationRule.scopeId != null" class="select-title"></div>
          </div>
          <div class="form-item form-floating mb-3">
            <input id="validation-starts-with" name="startsWith" type="text"
              [(ngModel)]="selectedValidationRule.startsWith" class="form-control" placeholder=" " />
            <label for="validation-starts-with">Starts with</label>
          </div>
          <div class="form-item form-floating mb-3">
            <select id="validation-rule-alphanumeric" name="validation-rule-alphanumeric"
              [(ngModel)]="selectedValidationRule.isAlfaNumeric"
              [ngClass]="selectedValidationRule.isAlfaNumeric != null ? 'selected-option' : ''" class="form-select">
              <option [ngValue]="null" disabled>Alphanumeric</option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
            <label *ngIf="selectedValidationRule.isAlfaNumeric != null" class="label-for-select"
              for="validation-rule-alphanumeric">Alphanumeric</label>
            <div *ngIf="selectedValidationRule.isAlfaNumeric != null" class="select-title"></div>
          </div>
          <div class="form-item form-floating mb-3">
            <input id="validation-regexp" name="regExp" type="text" [(ngModel)]="selectedValidationRule.regExp"
              class="form-control" placeholder=" " />
            <label for="validation-regexp">Regular Expression</label>
          </div>
        </div>
        <div class="modal-footer modal-footer-pattern">
          <button class="btn btn-primary" type="button" (click)="saveValidationRule()">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade validation-rule-modal" id="configurationGenerationModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="configurationGenerationModalTitle">
          Configuration Generation
        </h5>
        <button type="button" #closeConfigurationGenerationModal class="btn-cancel-modal" data-bs-dismiss="modal"
          aria-label="Close">
          Cancel
        </button>
      </div>
      <form id="configurationGenerationForm" class="form-wrapper" ngNativeValidate>
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <select id="configuration-generation-property" name="configuration-generation-property"
              [(ngModel)]="selectedConfigurationGeneration.propertyType"
              (ngModelChange)="onConfigurationGenerationTypeChange($event)" [disabled]="isEditConfigurationGeneration"
              [ngClass]="selectedConfigurationGeneration.propertyType != null ? 'selected-option' : ''"
              class="form-select" required>
              <option [ngValue]="null" disabled>Property Type</option>
              <option *ngFor="let ruleType of availableConfigurationGenerationTypeOptions" [ngValue]="ruleType.value">
                {{ ruleType.label }}
              </option>
            </select>
            <label *ngIf="selectedConfigurationGeneration.propertyType != null" class="label-for-select"
              for="configuration-generation-property">Property Type</label>
            <div *ngIf="selectedConfigurationGeneration.propertyType != null" class="select-title"></div>
          </div>
          <div class="form-item form-floating mb-3">
            <input id="character-length" name="characterLength" type="number"
              [(ngModel)]="selectedConfigurationGeneration.length" class="form-control" placeholder=" " />
            <label for="character-length">Character Length</label>
          </div>
          <div class="form-item form-floating mb-3">
            <select id="configuration-generation-format-type" name="configuration-generation-format-type"
              [(ngModel)]="selectedConfigurationGeneration.formatType"
              [ngClass]="selectedConfigurationGeneration.formatType != null ? 'selected-option' : ''"
              class="form-select">
              <option [ngValue]="null" disabled>Format Type</option>
              <option [ngValue]="1">Numeric</option>
              <option [ngValue]="2">Alphanumeric</option>
            </select>
            <label *ngIf="selectedConfigurationGeneration.formatType != null" class="label-for-select"
              for="configuration-generation-format-type">Format Type</label>
            <div *ngIf="selectedConfigurationGeneration.formatType != null" class="select-title"></div>
          </div>
          <div class="form-item form-floating mb-3">
            <input id="configuration-generation-starts-with" name="cgStartsWith" type="text"
              [(ngModel)]="selectedConfigurationGeneration.startsWith" class="form-control" placeholder=" " />
            <label for="configuration-generation-starts-with">Starts with</label>
          </div>
        </div>
        <div class="modal-footer modal-footer-pattern">
          <button class="btn btn-primary" type="button" (click)="saveConfigurationGeneration()">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="changeTranslation" tabindex="-1" aria-labelledby="changeTranslationTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Change translation
        </h5>
        <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          Cancel
        </button>
      </div>
      <form id="addForm" class="form-wrapper" ngNativeValidate (submit)="saveTranslation()">
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <input id="translationKey" name="name" type="text" [(ngModel)]="selectedTranslation.key" [disabled]="true"
              class="form-control" required placeholder=" " />
            <label for="translationKey">Key</label>
          </div>
          <div class="form-item form-floating mb-3">
            <input id="translationVal" name="code" type="text" [(ngModel)]="selectedTranslation.value"
              class="form-control" required placeholder=" " />
            <label for="translationVal">Value</label>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" form="addForm">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal fade" id="changeCodePattern" tabindex="-1" aria-labelledby="changeCodePatternTitle" aria-hidden="true"
  (hide.bs.modal)="clearCodePattern()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Change Code Pattern
        </h5>
        <button type="button" #closeCodeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          Cancel
        </button>
      </div>
      <form id="changeCodeForm" class="form-wrapper" ngNativeValidate (submit)="saveCodePattern()">
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <input id="assetType" name="assetType" type="text" [(ngModel)]="selectedCodePattern.displayAssetType"
              [disabled]="true" class="form-control" required placeholder=" " />
            <label for="assetType">Asset Type</label>
          </div>
          <div class="form-item form-floating mb-3 code-pattern-select">
            <select [(ngModel)]="selectedCodePatternOption" name="code-pattern-select" (change)="selectPattern($event)"
              class="form-item">
              <option class="dropdown-item" disabled selected value="undefined">Select Code Pattern...</option>

              <option *ngFor="let pattern of codePatternOptions" [value]="pattern.key">
                {{ pattern.value }}
              </option>
            </select>
          </div>
          <div class="form-item form-floating mb-3" *ngIf="showPrefix">
            <input id="codePrefix" name="prefix" type="text" [(ngModel)]="selectedCodePattern.prefix"
              class="form-control" required placeholder=" " />
            <label for="codePrefix">Prefix</label>
          </div>
        </div>
        <div class="modal-footer modal-footer-pattern">
          <button class="btn btn-primary" form="changeCodeForm">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true" data-bs-backdrop="true"
  data-bs-keyboard="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div *ngIf="this.selectedUtility" class="modal-body">
        <app-map-setup [setMapVisibility]="isMapVisible" [longitude]="this.selectedUtility.mapConfiguration?.longitude"
          [latitude]="this.selectedUtility.mapConfiguration?.latitude"
          [zoom]="this.selectedUtility.mapConfiguration?.zoom"
          (mapConfigurationSaved)="onMapConfigurationSaved($event)">
        </app-map-setup>
        <button #closeMapModalBtn type="button" class="btn btn-secondary d-none" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
